import { useEffect, useCallback } from 'react';

class EventBus extends EventTarget {
  emit(eventName: string, detail?: any) {
    this.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  on(eventName: string, callback: any) {
    this.addEventListener(eventName, callback);
  }

  off(eventName: string, callback: any) {
    this.removeEventListener(eventName, callback);
  }
}

const eventBus = new EventBus();

const useEventBus = (eventName: string, callback: any) => {
  const memoizedCallback = useCallback(
    (event: any) => callback(event.detail),
    [callback]
  );

  useEffect(() => {
    eventBus.on(eventName, memoizedCallback);

    return () => {
      eventBus.off(eventName, memoizedCallback);
    };
  }, [eventName, memoizedCallback]);
};

export { useEventBus, eventBus };
